var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreVertical = function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D636D",
    strokeWidth: 1.5,
    d: "M14 4.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM14 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM14 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
  })));
};
export default SvgMoreVertical;